import React from 'react';
import styles from './ServicioFreelance.module.css';
import RevealOnScroll from './RevealOnScroll';
import freelance from '../../assets/images/freelance.png';


export default function ServicioFreelance() {
  return (
    <RevealOnScroll as="section" className={styles.root} aria-label="Servicio de freelance">
      <div className={styles.inner}>
        <div className={styles.text}>
          <h2 className={styles.title}>Servicio de freelance</h2>
          <p className={styles.lead}>
            Ideal para ventas online, facturas de profesionales o negocios informales.
          </p>
        </div>

        <div className={styles.media}>
          <img
            src={freelance}
            alt="Servicio freelance"
            className={styles.image}
            loading="lazy"
          />
        </div>
      </div>
    </RevealOnScroll>
  );
}